import https from "https";

const defaults = {
  REACT_APP_UAT_CERCADEMI_ENDPOINT: "",
};

export default class WokkoCercaDeMi {
  constructor(options = {}) {
    this.options = { ...defaults, ...options };
    if (this.options.REACT_APP_UAT_CERCADEMI_ENDPOINT === "") {
      throw new Error("You must set REACT_APP_UAT_CERCADEMI_ENDPOINT option");
    }
    this.fetchCommerces = this.fetchCommerces.bind(this);
  }

  async fetchCommerces(lat, lng) {
    const endpoint = this.options.REACT_APP_UAT_CERCADEMI_ENDPOINT.concat(
      `/lat/${lat}/lng/${lng}/visibility-radius/1.4/`
    );

    const agent = new https.Agent({
      rejectUnauthorized: false,
    });

    const headers = new Headers({
      "x-api-key": process.env.REACT_APP_CERCADEMI_API_KEY,
    });

    return fetch(endpoint, { headers, agent })
      .then((e) => e.json())
      .then((res) => res)
      .catch((err) => err);
  }

  async fetchBrandAll() {
    const endpoint = this.options.REACT_APP_UAT_CERCADEMI_ENDPOINT

    const agent = new https.Agent({
      rejectUnauthorized: false,
    });

    const headers = new Headers({
      "x-api-key": process.env.REACT_APP_CERCADEMI_API_KEY,
    });

    return fetch(endpoint, { headers, agent })
      .then((e) => e.json())
      .then((res) => res)
      .catch((err) => err);
  }
}
